"use client";

import { Spinner } from "@/components/shadcn/spinner";
import { useTranslations } from "next-intl";

export function VideoDetailLoading() {
    return (
        <div className="flex w-full items-center justify-center py-10">
            <Spinner className="size-10" />
        </div>
    );
}

export function VideoDetailNotFound() {
    const t = useTranslations("series");

    return (
        <div className="w-full py-10">
            <div className="rounded bg-white p-8 text-center shadow">
                <p className="text-neutral-600">{t("notFound")}</p>
            </div>
        </div>
    );
}
